import { convertObjectNumbers } from 'Shared/Utils/Extensions/String/StringExtensions';
import { AxiosResponse } from 'axios';

import { apiInstanceType, onErrorType, onResultType, responseType } from '../Contracts/types';
import TrimJson from '../Utils/TrimJson';
import { downloadFile } from '../Utils/downloadFile';
import { ShowResponseError } from '../Utils/showResponseError';

export interface IHttpGetServiceProps {
  url: string;
  responseType?: responseType;
  onResult?: onResultType;
  onError?: onErrorType;
  isFile?: true | false;
  params?: object;
}

interface IProps extends IHttpGetServiceProps {
  API: apiInstanceType;
}

export const HttpGetService = async (props: IProps) => {
  if (props.onResult === undefined) {
    props.onResult = (res: AxiosResponse<any, any>): any => {
      if (res.status === 200 && props.isFile) {
        const fileType = res.headers['content-type'];
        const fileName = res.headers['content-disposition']?.split("''")[1] ?? '';

        downloadFile(res.data, fileName, fileType);
      }
      if (res.status === 200) {
        return res.data;
      }
    };
  }
  if (props.onError === undefined) {
    props.onError = (error: any) => {
      ShowResponseError(error);
    };
  }

  try {
    const params = convertObjectNumbers(TrimJson(props.params, false));
    const response = await props.API.get(props.url, {
      responseType: props.responseType,
      params: params,
    })
      .then(props.onResult)
      .catch(props.onError);
    return response;
  } catch (error) {
    ShowResponseError(error);
  }
};
